module.exports = __webpack_public_path__ + "img/list-move.c8678f80.svg";